import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class OpenAiService {
  private http = inject(HttpClient);
  chat(prompt: string) {
    const url = `${environment.apiBaseUrl}/openai/chat`;

    return this.http.post<any>(url, { 
      model: 'gpt-3.5-turbo',
      messages: [
        {
          role: 'system',
          content: 'Du bist ein sympathischer, technisch versierter KI-Partner für Angular- und Java-Themen. Antworte klar, praxisnah und mit einem Hauch Humor.'
        },
        { role: 'user', content: prompt }
      ]
          });
  }

  
}
